import { takeEvery, call, put } from 'redux-saga/effects';
import * as UrlUtil from '../utils/UrlUtil';
import {
    FETCH_FITNESSSTATS_ACTIVITY,
    FETCH_FITNESSSTATS_ACTIVITY_SUCCESS,
    FETCH_FITNESSSTATS_ACTIVITY_ERROR,
    FETCH_FITNESSSTATS_ACTIVITY_FETCHING,
    FETCH_RECENT_FITNESSSTATS_ACTIVITY,
    FETCH_RECENT_FITNESSSTATS_ACTIVITY_SUCCESS,
    FETCH_RECENT_FITNESSSTATS_ACTIVITY_FETCHING,
    FETCH_RECENT_FITNESSSTATS_ACTIVITY_ERROR,
    FETCH_USER_AVERAGE_PACE,
    FETCH_USER_AVERAGE_PACE_SUCCESS,
    FETCH_USER_AVERAGE_PACE_FETCHING,
    FETCH_USER_AVERAGE_PACE_ERROR,
    FETCH_ALL_FITNESSSTATS_ACTIVITY,
    FETCH_ALL_FITNESSSTATS_ACTIVITY_FETCHING,
    FETCH_ALL_FITNESSSTATS_ACTIVITY_SUCCESS,
    FETCH_ALL_FITNESSSTATS_ACTIVITY_ERROR
} from '../actions/statsActions';
import { gcApi } from '../config/axios';
import DateParser from 'utils/date/DateParser';

// worker
export function* fetchFitnessStatsActivity(action) {
    try {
        yield put({
            type: FETCH_FITNESSSTATS_ACTIVITY_FETCHING,
            ...action.payload
        });

        const {
            aggregation,
            groupBy,
            userFirstDay,
            startDate,
            endDate,
            metrics,
            activityType,
            standardizedUnits
        } = action.payload;
        const queryParams = UrlUtil.toQueryString({
            aggregation,
            groupByParentActivityType: groupBy === 'ACTIVITY',
            groupByEventType: groupBy === 'EVENT',
            activityType,
            userFirstDay,
            startDate,
            endDate,
            metric: metrics,
            standardizedUnits
        });
        const response = yield call(gcApi.get, `/fitnessstats-service/activity${queryParams}`);

        yield put({
            type: FETCH_FITNESSSTATS_ACTIVITY_SUCCESS,
            ...action.payload,
            stats: response.data
        });
    } catch (e) {
        // Handling Error
        yield put({
            type: FETCH_FITNESSSTATS_ACTIVITY_ERROR,
            data: []
        });
    }
}

// worker
export function* fetchRecentFitnessStatsActivity(action) {
    yield put({
        type: FETCH_RECENT_FITNESSSTATS_ACTIVITY_FETCHING,
        ...action.payload
    });

    try {
        const { activityType, metric } = action.payload;
        const response = yield call(
            gcApi.get,
            `/fitnessstats-service/activity/training/recent/${activityType}?metric=${metric}`
        );
        yield put({
            type: FETCH_RECENT_FITNESSSTATS_ACTIVITY_SUCCESS,
            metric: metric,
            stats: response.data
        });
    } catch (e) {
        // Handling Error
        yield put({
            type: FETCH_RECENT_FITNESSSTATS_ACTIVITY_ERROR,
            data: {}
        });
    }
}

export function* fetchUserAveragePace(action) {
    yield put({
        type: FETCH_USER_AVERAGE_PACE_FETCHING
    });

    try {
        const { activityType } = action.payload;
        const response = yield call(
            gcApi.get,
            `/fitnessstats-service/activity/userAvgSpeed?activityType=${activityType}`
        );
        yield put({
            type: FETCH_USER_AVERAGE_PACE_SUCCESS,
            userAveragePace: response.data,
            activityType
        });
    } catch (e) {
        // Handling Error
        yield put({
            type: FETCH_USER_AVERAGE_PACE_ERROR
        });
    }
}

export function* fetchAllFitnessStatsActivity(action) {
    yield put({
        type: FETCH_ALL_FITNESSSTATS_ACTIVITY_FETCHING,
        ...action.payload
    });

    try {
        const { startDate, endDate, key, activityType, metrics, standardizedUnits, excludeSort } = action.payload;
        let url = `/fitnessstats-service/activity/all`;

        const START_LOCAL_METRIC = 'startLocal';
        const allMetrics = [...metrics];

        // add START_LOCAL_METRIC if doesn't exist, to use to sort later
        if (!metrics?.includes(START_LOCAL_METRIC)) {
            allMetrics.push(START_LOCAL_METRIC);
        }

        const queryParams = UrlUtil.toQueryString({
            startDate,
            endDate,
            activityType,
            metric: allMetrics,
            standardizedUnits
        });

        const response = yield call(gcApi.get, url + queryParams);

        yield put({
            type: FETCH_ALL_FITNESSSTATS_ACTIVITY_SUCCESS,
            startDate: startDate,
            endDate: endDate,
            key: key,
            allFitnessStats: excludeSort
                ? response.data
                : response.data.toSorted((a, b) => {
                      // sort in descending
                      return +DateParser.parseISO(b[START_LOCAL_METRIC]) - +DateParser.parseISO(a[START_LOCAL_METRIC]);
                  })
        });
    } catch (e) {
        const { startDate, endDate, key } = action.payload;
        // Handling Error
        yield put({
            type: FETCH_ALL_FITNESSSTATS_ACTIVITY_ERROR,
            startDate: startDate,
            endDate: endDate,
            key: key,
            data: []
        });
    }
}

// watcher
export const fitnessStatsSagas = [
    takeEvery(FETCH_FITNESSSTATS_ACTIVITY, fetchFitnessStatsActivity),
    takeEvery(FETCH_RECENT_FITNESSSTATS_ACTIVITY, fetchRecentFitnessStatsActivity),
    takeEvery(FETCH_USER_AVERAGE_PACE, fetchUserAveragePace),
    takeEvery(FETCH_ALL_FITNESSSTATS_ACTIVITY, fetchAllFitnessStatsActivity)
];
